import React, { useContext, useEffect, useState } from "react";

import { FormNavigationController } from "../common/components/FormNavigationController";
import { FormTitle } from "../common/components/generalUtilities";
import { ObservationFormContext } from "../hooks/ObservationFormContext";
import { ObservationForm } from "./ObservationForm";
import { ObservationPreview } from "./ObservationPreview";

import { ObservationGoalTemplate } from "../classes/goal_template_observation_class";
import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";

export const ObservationContainer: React.FunctionComponent = () => {
  const { DBObject, t, navPage } = useContext(TMDataContext);

  let observationDefaults = navPage.formDefaults
    ? navPage.formDefaults
    : { user: DBObject.User };

  const observationGoalObject = new ObservationGoalTemplate(
    observationDefaults
  );
  const [CRUDtype] = useState(navPage.formDefaults ? "edit" : "new");

  const [goalState, setGoalState] = useState(observationGoalObject);
  const [formComplete, setFormComplete] = useState(false);
  const [formPrompt, setFormPrompt] = useState(
    observationGoalObject.measurementId ? true : false
  );

  const showStep = () => {
    switch (navPage.name) {
      case "observationForm":
        return (
          <ObservationForm
            setStepComplete={setFormComplete}
            formPrompt={formPrompt}
            setFormPrompt={setFormPrompt}
          />
        );
        break;
      case "observationPreview":
        return <ObservationPreview />;
        break;
    }
  };

  return (
    <ObservationFormContext.Provider
      value={{
        goalState,
        setGoalState,
      }}
    >
      <div className="goal-wizard-container">
        <FormTitle
          title={t(
            `views.goals.form_titles.observation_goal_${CRUDtype}${
              navPage.name.includes("Preview") && CRUDtype ? "_preview" : ""
            }`
          )}
        />
        <div className="goal-form-dashboard">{showStep()}</div>
        <FormNavigationController
          stepComplete={formComplete}
          goalState={goalState}
        />
      </div>
    </ObservationFormContext.Provider>
  );
};
